import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Theme } from '../../config/theme.js';

import { subscribeToNewsletter } from '../../actions/content';

import TextField from '../../components/TextField';
import Button from '../../components/Button';
import CheckboxField from '../../components/CheckboxField';

const CLOSE_ICON = require('./close.svg');
const MAIL_IMAGE = require('./mail.png');

export default class NextSongModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      hiphop: false,
      indie: false,
      pop: false,
      electronic: false,
      subscribed: false,
    };

    this.setValue = this.updateField.bind(this);
  }

  _closeOverlay() {
    this.setState({
      goToNextSong: false,
    });

    this.props.dispatch({
      type: 'HIDE_NEWSLETTER_MODAL',
      payload: true,
    });
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  signup() {
    this.setState({
      subscribed: true,
    });
    this.props.dispatch(subscribeToNewsletter(this.state));
  }

  render() {
    return (
      <div className={css(styles.overlay_container)}>
        <div className={css(styles.clickable_container)} onClick={this._closeOverlay.bind(this)} />
        <div className={css(styles.container)}>
          <div onClick={this._closeOverlay.bind(this)} className={css(styles.close_container)}>
            <div className={css(styles.close_text)}>close</div> <img src={CLOSE_ICON} className={css(styles.close_icon)} />
          </div>
          <div className={css(styles.articles_container)}>
            <div className={css(styles.image_container)}>
              <img className={css(styles.image)} src={MAIL_IMAGE} />
            </div>
            <p className={css(styles.para)}>Keep that nose hot by sniffing out the latest, subscribe to our mailing list below!</p>
            <div className={css(styles.form_group)}>
              <CheckboxField
                id="hiphop"
                name="hiphop"
                label="Hip Hop"
                fullWidth
                handler={this.setValue}
                value={this.state.hiphop}
              />
              <CheckboxField
                id="indie"
                name="indie"
                label="Indie"
                fullWidth
                handler={this.setValue}
                value={this.state.indie}
              />
              <CheckboxField
                id="pop"
                name="pop"
                label="Pop"
                fullWidth
                handler={this.setValue}
                value={this.state.pop}
              />
              <CheckboxField
                id="electronic"
                name="electronic"
                label="Electronic"
                fullWidth
                handler={this.setValue}
                value={this.state.electronic}
              />
            </div>
            <div className={css(styles.form)}>
              <TextField fullWith placeholder="Enter your email address" name="email" handler={this.setValue} value={this.state.email} />
              <br/>
              <div className={css(styles.button_container)}>
                <Button handler={this.signup.bind(this)} title="Sign up" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  overlay_container: {
    position: 'fixed',
    zIndex: 100,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(5,9,14,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    zIndex: 10,
    padding: '20px 60px 20px',
    width: 440,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    borderRadius: 5,
    boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'solid 1px #e4e4e4',
  },
  buttons: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
  },
  spacer: {
    backgroundColor: 'transparent',
    height: 30,
    width: 30,
  },
  image_container: {
    position: 'relative',
    marginBottom: 25,
  },
  image: {
    width: 140,
  },
  para: {
    display: 'block',
    fontFamily: Theme.fontFamily,
    marginBottom: 20,
    textAlign: 'center',
    lineHeight: '22px',
  },
  clickable_container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  close_container: {
    position: 'absolute',
    top: -40,
    right: 0,
    textAlign: 'right',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.5,
    },
  },
  close_text: {
    display: 'inline-block',
    fontFamily: Theme.fontFamily,
    letterSpacing: 1,
    fontSize: 14,
    color: Theme.white,
  },
  close_icon: {
    position: 'relative',
    top: 1,
    width: 10,
    height: 10,
  },
  search_container: {
    display: 'flex',
    marginRight: 30,
    borderBottom: `1px solid ${Theme.grey}`,
    alignItems: 'center',
  },
  search_icon_container: {
    flex: 1,
  },
  search_icon: {
    marginRight: 30,
    marginBottom: 10,
  },
  'search_input_container': {
    flex: 9,
  },
  articles_container: {
    paddingTop: 30,
    paddingBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap",
    flexDirection: 'column',
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0px 20px',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    width: 500,
    justifyContent: 'center',
  },
  button_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    height: 50,
    marginLeft: -5,
  },
});



// WEBPACK FOOTER //
// ./src/components/NewsletterModal/index.js